import React from "react";
import { Field, Formik } from "formik";
import { object } from "yup";
import Button from "@material-ui/core/Button/Button";
import Grid from "@material-ui/core/Grid";
import { Api } from "../../utils/api";
import { MaterialSelectFormik } from "../components/establishments-select-field.component";
import { CircularProgress } from "@material-ui/core";
import { CheckboxWithLabel } from "formik-material-ui";

const validationSchema = object().shape({});

const handleSubmitting = (fn) => (values, actions) => {
  fn(values);
  actions.setSubmitting(false);
};
// servicos_de_base
const servicos_de_base_alimentacao_e_hidratacaoToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const servicos_de_base_alimentacao_e_hidratacaoOptionsPromise = () => {
  const api = new Api();
  const input = "servicos_de_base_alimentacao_e_hidratacao";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(servicos_de_base_alimentacao_e_hidratacaoToSelect);
};

// tipos_de_alojamento
const tipos_de_alojamento_quartos_individuaisToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const tipos_de_alojamento_quartos_individuaisOptionsPromise = () => {
  const api = new Api();
  const input = "tipos_de_alojamento_quartos_individuais";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(tipos_de_alojamento_quartos_individuaisToSelect);
};

const tipos_de_alojamento_suites_individuaisToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const tipos_de_alojamento_suites_individuaisOptionsPromise = () => {
  const api = new Api();
  const input = "tipos_de_alojamento_suites_individuais";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(tipos_de_alojamento_suites_individuaisToSelect);
};

const tipos_de_alojamento_suites_duplasToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const tipos_de_alojamento_suites_duplasOptionsPromise = () => {
  const api = new Api();
  const input = "tipos_de_alojamento_suites_duplas";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(tipos_de_alojamento_suites_duplasToSelect);
};

const tipos_de_alojamento_apartamentosToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const tipos_de_alojamento_apartamentosOptionsPromise = () => {
  const api = new Api();
  const input = "tipos_de_alojamento_apartamentos";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(tipos_de_alojamento_apartamentosToSelect);
};

// patologias_aceites
const patologias_aceites_esquizofreniaToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const patologias_aceites_esquizofreniaOptionsPromise = () => {
  const api = new Api();
  const input = "patologias_aceites_esquizofrenia";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(patologias_aceites_esquizofreniaToSelect);
};

// cuidados_de_saude
const cuidados_de_saude_psicomotricidadeToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const cuidados_de_saude_psicomotricidadeOptionsPromise = () => {
  const api = new Api();
  const input = "cuidados_de_saude_psicomotricidade";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(cuidados_de_saude_psicomotricidadeToSelect);
};

const cuidados_de_saude_terapia_de_snoezelenToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const cuidados_de_saude_terapia_de_snoezelenOptionsPromise = () => {
  const api = new Api();
  const input = "cuidados_de_saude_terapia_de_snoezelen";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(cuidados_de_saude_terapia_de_snoezelenToSelect);
};

const cuidados_de_saude_ortopediaToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const cuidados_de_saude_ortopediaOptionsPromise = () => {
  const api = new Api();
  const input = "cuidados_de_saude_ortopedia";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(cuidados_de_saude_ortopediaToSelect);
};

const cuidados_de_saude_acupunturaToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const cuidados_de_saude_acupunturaOptionsPromise = () => {
  const api = new Api();
  const input = "cuidados_de_saude_acupuntura";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(cuidados_de_saude_acupunturaToSelect);
};

const cuidados_de_saude_medico_de_clinica_geralToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const cuidados_de_saude_medico_de_clinica_geralOptionsPromise = () => {
  const api = new Api();
  const input = "cuidados_de_saude_medico_de_clinica_geral";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(cuidados_de_saude_medico_de_clinica_geralToSelect);
};

const cuidados_de_saude_enfermagemToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const cuidados_de_saude_enfermagemOptionsPromise = () => {
  const api = new Api();
  const input = "cuidados_de_saude_enfermagem";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(cuidados_de_saude_enfermagemToSelect);
};

const cuidados_de_saude_neurologistaToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const cuidados_de_saude_neurologistaOptionsPromise = () => {
  const api = new Api();
  const input = "cuidados_de_saude_neurologista";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(cuidados_de_saude_neurologistaToSelect);
};

const cuidados_de_saude_psicologoToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const cuidados_de_saude_psicologoOptionsPromise = () => {
  const api = new Api();
  const input = "cuidados_de_saude_psicologo";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(cuidados_de_saude_psicologoToSelect);
};

const cuidados_de_saude_fisioterapia_de_grupoToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const cuidados_de_saude_fisioterapia_de_grupoOptionsPromise = () => {
  const api = new Api();
  const input = "cuidados_de_saude_fisioterapia_de_grupo";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(cuidados_de_saude_fisioterapia_de_grupoToSelect);
};

const cuidados_de_saude_fisioterapia_personalizadaToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const cuidados_de_saude_fisioterapia_personalizadaOptionsPromise = () => {
  const api = new Api();
  const input = "cuidados_de_saude_fisioterapia_personalizada";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(cuidados_de_saude_fisioterapia_personalizadaToSelect);
};

const cuidados_de_saude_terapia_da_falaToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const cuidados_de_saude_terapia_da_falaOptionsPromise = () => {
  const api = new Api();
  const input = "cuidados_de_saude_terapia_da_fala";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(cuidados_de_saude_terapia_da_falaToSelect);
};

// ocupacao
const ocupacao_terapia_ocupacionalToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const ocupacao_terapia_ocupacionalOptionsPromise = () => {
  const api = new Api();
  const input = "ocupacao_terapia_ocupacional";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(ocupacao_terapia_ocupacionalToSelect);
};

const ocupacao_animacao_socioculturalToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const ocupacao_animacao_socioculturalOptionsPromise = () => {
  const api = new Api();
  const input = "ocupacao_animacao_sociocultural";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(ocupacao_animacao_socioculturalToSelect);
};

// plano_de_atividades
const plano_de_atividades_atelier_de_costuraToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const plano_de_atividades_atelier_de_costuraOptionsPromise = () => {
  const api = new Api();
  const input = "plano_de_atividades_atelier_de_costura";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(plano_de_atividades_atelier_de_costuraToSelect);
};

const plano_de_atividades_hidroterapiaToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const plano_de_atividades_hidroterapiaOptionsPromise = () => {
  const api = new Api();
  const input = "plano_de_atividades_hidroterapia";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(plano_de_atividades_hidroterapiaToSelect);
};

const plano_de_atividades_musicoterapiaToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const plano_de_atividades_musicoterapiaOptionsPromise = () => {
  const api = new Api();
  const input = "plano_de_atividades_musicoterapia";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(plano_de_atividades_musicoterapiaToSelect);
};

const plano_de_atividades_manutencao_fisicaToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const plano_de_atividades_manutencao_fisicaOptionsPromise = () => {
  const api = new Api();
  const input = "plano_de_atividades_manutencao_fisica";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(plano_de_atividades_manutencao_fisicaToSelect);
};

const plano_de_atividades_jardinagemToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const plano_de_atividades_jardinagemOptionsPromise = () => {
  const api = new Api();
  const input = "plano_de_atividades_jardinagem";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(plano_de_atividades_jardinagemToSelect);
};

const plano_de_atividades_estimulação_cognitivaToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const plano_de_atividades_estimulação_cognitivaOptionsPromise = () => {
  const api = new Api();
  const input = "plano_de_atividades_estimulação_cognitiva";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(plano_de_atividades_estimulação_cognitivaToSelect);
};

const plano_de_atividades_terapia_snoezelenToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const plano_de_atividades_terapia_snoezelenOptionsPromise = () => {
  const api = new Api();
  const input = "plano_de_atividades_terapia_snoezelen";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(plano_de_atividades_terapia_snoezelenToSelect);
};

const plano_de_atividades_expressao_plasticaToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const plano_de_atividades_expressao_plasticaOptionsPromise = () => {
  const api = new Api();
  const input = "plano_de_atividades_expressao_plastica";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(plano_de_atividades_expressao_plasticaToSelect);
};

const plano_de_atividades_passeios_e_visitas_culturaisToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const plano_de_atividades_passeios_e_visitas_culturaisOptionsPromise = () => {
  const api = new Api();
  const input = "plano_de_atividades_passeios_e_visitas_culturais";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(plano_de_atividades_passeios_e_visitas_culturaisToSelect);
};

const plano_de_atividades_novas_tecnologiasToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const plano_de_atividades_novas_tecnologiasOptionsPromise = () => {
  const api = new Api();
  const input = "plano_de_atividades_novas_tecnologias";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(plano_de_atividades_novas_tecnologiasToSelect);
};

const plano_de_atividades_atelier_de_escrita_criativaToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const plano_de_atividades_atelier_de_escrita_criativaOptionsPromise = () => {
  const api = new Api();
  const input = "plano_de_atividades_atelier_de_escrita_criativa";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(plano_de_atividades_atelier_de_escrita_criativaToSelect);
};

const plano_de_atividades_celebracao_da_palavraToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const plano_de_atividades_celebracao_da_palavraOptionsPromise = () => {
  const api = new Api();
  const input = "plano_de_atividades_celebracao_da_palavra";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(plano_de_atividades_celebracao_da_palavraToSelect);
};

const plano_de_atividades_atelier_de_culinariaToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const plano_de_atividades_atelier_de_culinariaOptionsPromise = () => {
  const api = new Api();
  const input = "plano_de_atividades_atelier_de_culinaria";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(plano_de_atividades_atelier_de_culinariaToSelect);
};

const plano_de_atividades_aulas_de_dancaToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const plano_de_atividades_aulas_de_dancaOptionsPromise = () => {
  const api = new Api();
  const input = "plano_de_atividades_aulas_de_danca";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(plano_de_atividades_aulas_de_dancaToSelect);
};

const plano_de_atividades_hidroginasticaToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const plano_de_atividades_hidroginasticaOptionsPromise = () => {
  const api = new Api();
  const input = "plano_de_atividades_hidroginastica";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(plano_de_atividades_hidroginasticaToSelect);
};

const plano_de_atividades_atelier_de_teatroToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const plano_de_atividades_atelier_de_teatroOptionsPromise = () => {
  const api = new Api();
  const input = "plano_de_atividades_atelier_de_teatro";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(plano_de_atividades_atelier_de_teatroToSelect);
};

const plano_de_atividades_bailesToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const plano_de_atividades_bailesOptionsPromise = () => {
  const api = new Api();
  const input = "plano_de_atividades_bailes";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(plano_de_atividades_bailesToSelect);
};

const plano_de_atividades_aulas_de_motricidadeToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const plano_de_atividades_aulas_de_motricidadeOptionsPromise = () => {
  const api = new Api();
  const input = "plano_de_atividades_aulas_de_motricidade";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(plano_de_atividades_aulas_de_motricidadeToSelect);
};

const plano_de_atividades_hipoterapiaToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const plano_de_atividades_hipoterapiaOptionsPromise = () => {
  const api = new Api();
  const input = "plano_de_atividades_hipoterapia";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(plano_de_atividades_hipoterapiaToSelect);
};

const plano_de_atividades_expressao_musicalToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const plano_de_atividades_expressao_musicalOptionsPromise = () => {
  const api = new Api();
  const input = "plano_de_atividades_expressao_musical";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(plano_de_atividades_expressao_musicalToSelect);
};

// health_unities
const health_unities_hospitalToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const health_unities_hospitalOptionsPromise = () => {
  const api = new Api();
  const input = "health_unities_hospital";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(health_unities_hospitalToSelect);
};

const health_unities_centro_de_saudeToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const health_unities_centro_de_saudeOptionsPromise = () => {
  const api = new Api();
  const input = "health_unities_centro_de_saude";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(health_unities_centro_de_saudeToSelect);
};

// transportes_proximos
const transportes_proximos_autocarroToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const transportes_proximos_autocarroOptionsPromise = () => {
  const api = new Api();
  const input = "transportes_proximos_autocarro";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(transportes_proximos_autocarroToSelect);
};

const transportes_proximos_comboioToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const transportes_proximos_comboioOptionsPromise = () => {
  const api = new Api();
  const input = "transportes_proximos_comboio";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(transportes_proximos_comboioToSelect);
};

const transportes_proximos_metroToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const transportes_proximos_metroOptionsPromise = () => {
  const api = new Api();
  const input = "transportes_proximos_metro";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(transportes_proximos_metroToSelect);
};

const transportes_proximos_praca_de_taxisToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const transportes_proximos_praca_de_taxisOptionsPromise = () => {
  const api = new Api();
  const input = "transportes_proximos_praca_de_taxis";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(transportes_proximos_praca_de_taxisToSelect);
};

const transportes_proximos_barcoToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const transportes_proximos_barcoOptionsPromise = () => {
  const api = new Api();
  const input = "transportes_proximos_barco";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(transportes_proximos_barcoToSelect);
};

const transportes_proximos_aeroportoToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const transportes_proximos_aeroportoOptionsPromise = () => {
  const api = new Api();
  const input = "transportes_proximos_aeroporto";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(transportes_proximos_aeroportoToSelect);
};

const transportes_proximos_eletricoToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const transportes_proximos_eletricoOptionsPromise = () => {
  const api = new Api();
  const input = "transportes_proximos_eletrico";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(transportes_proximos_eletricoToSelect);
};

// aeroportos_de_portugal
const aeroportos_de_portugal_humberto_delgadoToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const aeroportos_de_portugal_humberto_delgadoOptionsPromise = () => {
  const api = new Api();
  const input = "aeroportos_de_portugal_humberto_delgado";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(aeroportos_de_portugal_humberto_delgadoToSelect);
};

const aeroportos_de_portugal_francisco_sa_carneiroToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const aeroportos_de_portugal_francisco_sa_carneiroOptionsPromise = () => {
  const api = new Api();
  const input = "aeroportos_de_portugal_francisco_sa_carneiro";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(aeroportos_de_portugal_francisco_sa_carneiroToSelect);
};

const aeroportos_de_portugal_internacional_de_faroToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const aeroportos_de_portugal_internacional_de_faroOptionsPromise = () => {
  const api = new Api();
  const input = "aeroportos_de_portugal_internacional_de_faro";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(aeroportos_de_portugal_internacional_de_faroToSelect);
};

const aeroportos_de_portugal_internacional_do_alentejoToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const aeroportos_de_portugal_internacional_do_alentejoOptionsPromise = () => {
  const api = new Api();
  const input = "aeroportos_de_portugal_internacional_do_alentejo";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(aeroportos_de_portugal_internacional_do_alentejoToSelect);
};

// aceita
const aceita_65_anosToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const aceita_65_anosOptionsPromise = () => {
  const api = new Api();
  const input = "aceita_65_anos";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(aceita_65_anosToSelect);
};

const aceita_estrangeirosToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};
const aceita_estrangeirosOptionsPromise = () => {
  const api = new Api();
  const input = "aceita_estrangeiros";
  return api
    .get("/services", { input })
    .then((res) => res.data)
    .then(aceita_estrangeirosToSelect);
};

export const EstablishmentServicesForm = ({
  onSubmit,
  establishment,
  services,
  servicesComboboxes,
  isUpdating,
}) => (
  <Formik
    initialValues={{
      id: establishment.id,
//Tipo
      erpi: services.find(s=>s.checkboxes == "erpi").is_checkactive == "1",
      ucci: services.find(s=>s.checkboxes == "ucci").is_checkactive == "1",
      ucrm: services.find(s=>s.checkboxes == "ucrm").is_checkactive == "1",
      hotel: services.find(s=>s.checkboxes == "hotel").is_checkactive == "1",
      al: services.find(s=>s.checkboxes == "al").is_checkactive == "1",
      casa_particular: services.find(s=>s.checkboxes == "casa_particular").is_checkactive == "1",
      cohousing: services.find(s=>s.checkboxes == "cohousing").is_checkactive == "1",
//Destinatários
      independentes: services.find(s=>s.checkboxes == "independentes").is_checkactive == "1",
      dependentes: services.find(s=>s.id == "120").is_checkactive == "1",
      muito_dependentes: services.find(s=>s.checkboxes == "muito_dependentes").is_checkactive == "1",
      acamados: services.find(s=>s.checkboxes == "acamados").is_checkactive == "1",
//Serviços de Base
      alojamento_e_conforto: services.find(s=>s.checkboxes == "alojamento_e_conforto").is_checkactive == "1",
      higiene_e_apresentacao: services.find(s=>s.checkboxes == "higiene_e_apresentacao").is_checkactive == "1",
      apoio_nas_actividades_diarias: services.find(s=>s.checkboxes == "apoio_nas_actividades_diarias").is_checkactive == "1",
      tratamento_de_roupa: services.find(s=>s.id == "93").is_checkactive == "1",
      alimentacao_e_hidratacao: services.find(s=>s.checkboxes == "alimentacao_e_hidratacao").is_checkactive == "1",
//Tipos de Alojamento
      quartos_duplos: services.find(s=>s.checkboxes == "quartos_duplos").is_checkactive == "1",
      quartos_triplos: services.find(s=>s.checkboxes == "quartos_triplos").is_checkactive == "1",
      quartos_individuais: services.find(s=>s.checkboxes == "quartos_individuais").is_checkactive == "1",
      suites_individuais: services.find(s=>s.checkboxes == "suites_individuais").is_checkactive == "1",
      suites_duplas: services.find(s=>s.checkboxes == "suites_duplas").is_checkactive == "1",
      apartamentos: services.find(s=>s.checkboxes == "apartamentos").is_checkactive == "1",
      moradias_t0: services.find(s=>s.checkboxes == "moradias_t0").is_checkactive == "1",
//Detalhes nos quartos
      aquecimento_central: services.find(s=>s.checkboxes == "aquecimento_central").is_checkactive == "1",
      televisao_por_cabo: services.find(s=>s.checkboxes == "televisao_por_cabo").is_checkactive == "1",
      camas_articuladas: services.find(s=>s.checkboxes == "camas_articuladas").is_checkactive == "1",
      colchoes_anti_escaras: services.find(s=>s.checkboxes == "colchoes_anti_escaras").is_checkactive == "1",
      sistema_de_chamada: services.find(s=>s.checkboxes == "sistema_de_chamada").is_checkactive == "1",
      ar_condicionado: services.find(s=>s.checkboxes == "ar_condicionado").is_checkactive == "1",
      cofre_individual: services.find(s=>s.checkboxes == "cofre_individual").is_checkactive == "1",
//Segurança e Acessibilidade
      plataforma_elevatoria: services.find(s=>s.checkboxes == "plataforma_elevatoria").is_checkactive == "1",
      ajudas_tecnicas: services.find(s=>s.id == "494").is_checkactive == "1",
      elevador_de_servicos: services.find(s=>s.checkboxes == "elevador_de_servicos").is_checkactive == "1",
      cadeira_elevatoria: services.find(s=>s.checkboxes == "cadeira_elevatoria").is_checkactive == "1",
      banho_geriatrico: services.find(s=>s.checkboxes == "banho_geriatrico").is_checkactive == "1",
//Patologias Aceites
      alzheimer: services.find(s=>s.checkboxes == "alzheimer").is_checkactive == "1",
      parkinson: services.find(s=>s.id == "277").is_checkactive == "1",
      demencia: services.find(s=>s.id == "395").is_checkactive == "1",
      hiv: services.find(s=>s.id == "278").is_checkactive == "1",
      esquizofrenia: services.find(s=>s.id == "275").is_checkactive == "1",
      alcoolismo: services.find(s=>s.id == "333").is_checkactive == "1",
//Cuidados de Saúde
      psicomotricidade: services.find(s=>s.checkboxes == "psicomotricidade").is_checkactive == "1",    
      terapia_de_snoezelen: services.find(s=>s.checkboxes == "terapia_de_snoezelen").is_checkactive == "1",
      nutricionista: services.find(s=>s.checkboxes == "nutricionista").is_checkactive == "1",
      ortopedia: services.find(s=>s.id == "429").is_checkactive == "1",
      acupuntura: services.find(s=>s.checkboxes == "acupuntura").is_checkactive == "1",
      psicogerontologia: services.find(s=>s.checkboxes == "psicogerontologia").is_checkactive == "1",
      terapia_de_reminiscencia: services.find(s=>s.checkboxes == "terapia_de_reminiscencia").is_checkactive == "1",
      medico_de_clinica_geral: services.find(s=>s.id == "284").is_checkactive == "1", 
      enfermagem: services.find(s=>s.id == "285").is_checkactive == "1",
      neurologista: services.find(s=>s.checkboxes == "neurologista").is_checkactive == "1",
      psicologo: services.find(s=>s.checkboxes == "psicologo").is_checkactive == "1",
      fisioterapia_de_grupo: services.find(s=>s.id == "314").is_checkactive == "1",
      fisioterapia_personalizada: services.find(s=>s.id == "286").is_checkactive == "1",
      terapia_da_fala: services.find(s=>s.id == "310").is_checkactive == "1",
      psiquiatra: services.find(s=>s.checkboxes == "psiquiatra").is_checkactive == "1",
//Ofertas
      material_de_incontinencia: services.find(s=>s.checkboxes == "material_de_incontinencia").is_checkactive == "1",
      material_de_enfermagem: services.find(s=>s.checkboxes == "material_de_enfermagem").is_checkactive == "1",
//Serviços Opcionais
      barbeiro: services.find(s=>s.checkboxes == "barbeiro").is_checkactive == "1",
      yoga: services.find(s=>s.checkboxes == "yoga").is_checkactive == "1",
      lavandaria: services.find(s=>s.checkboxes == "lavandaria").is_checkactive == "1",
      acompanhamento: services.find(s=>s.id == "485").is_checkactive == "1",
      transporte: services.find(s=>s.id == "270").is_checkactive == "1",
      cabeleireiro: services.find(s=>s.id == "312").is_checkactive == "1",
      manicure: services.find(s=>s.id == "406").is_checkactive == "1",
      podologista: services.find(s=>s.id == "313").is_checkactive == "1",
      massagem: services.find(s=>s.id == "103").is_checkactive == "1",
      reiki: services.find(s=>s.checkboxes == "reiki").is_checkactive == "1",
      pilates: services.find(s=>s.checkboxes == "pilates").is_checkactive == "1",
//Ocupação
      terapia_ocupacional: services.find(s=>s.checkboxes == "terapeuta_ocupacional").is_checkactive == "1",
      animacao_sociocultural: services.find(s=>s.checkboxes == "animacao_sociocultural").is_checkactive == "1",
//Plano de Actividades
      atelier_de_costura: services.find(s=>s.checkboxes == "atelier_de_costura").is_checkactive == "1",
      hidroterapia: services.find(s=>s.checkboxes == "hidroterapia").is_checkactive == "1",
      musicoterapia: services.find(s=>s.checkboxes == "musicoterapia").is_checkactive == "1",
      manutencao_fisica: services.find(s=>s.checkboxes == "manutencao_fisica").is_checkactive == "1",
      jardinagem: services.find(s=>s.checkboxes == "jardinagem").is_checkactive == "1",
      estimulacao_cognitiva: services.find(s=>s.checkboxes == "estimulacao_cognitiva").is_checkactive == "1",
      terapia_snoezelen: services.find(s=>s.checkboxes == "terapia_snoezelen").is_checkactive == "1",
      expressao_plastica: services.find(s=>s.checkboxes == "expressao_plastica").is_checkactive == "1",
      passeios_e_visitas_culturais: services.find(s=>s.checkboxes == "passeios_e_visitas_culturais").is_checkactive == "1",
      novas_tecnologias: services.find(s=>s.checkboxes == "novas_tecnologias").is_checkactive == "1",
      atelier_de_escrita_criativa: services.find(s=>s.checkboxes == "atelier_de_escrita_criativa").is_checkactive == "1",
      celebracao_da_palavra: services.find(s=>s.checkboxes == "celebracao_da_palavra").is_checkactive == "1",
      atelier_de_culinaria: services.find(s=>s.checkboxes == "atelier_de_culinaria").is_checkactive == "1",
      aulas_de_danca: services.find(s=>s.checkboxes == "aulas_de_danca").is_checkactive == "1",
      estimulacao_funcional: services.find(s=>s.checkboxes == "estimulacao_funcional").is_checkactive == "1",
      terapia_assistida_por_animais: services.find(s=>s.checkboxes == "terapia_assistida_por_animais").is_checkactive == "1",
      atelier_de_leitura: services.find(s=>s.checkboxes == "atelier_de_leitura").is_checkactive == "1",
      hidroginastica: services.find(s=>s.checkboxes == "hidroginastica").is_checkactive == "1",
      atelier_de_teatro: services.find(s=>s.checkboxes == "atelier_de_teatro").is_checkactive == "1",
      estimulacao_sensorial: services.find(s=>s.checkboxes == "estimulacao_sensorial").is_checkactive == "1",
      bailes: services.find(s=>s.checkboxes == "bailes").is_checkactive == "1",
      aulas_de_motricidade: services.find(s=>s.checkboxes == "aulas_de_motricidade").is_checkactive == "1",
      hipoterapia: services.find(s=>s.checkboxes == "hipoterapia").is_checkactive == "1",
      expressao_musical: services.find(s=>s.checkboxes == "expressao_musical").is_checkactive == "1",
      canto_coral: services.find(s=>s.checkboxes == "canto_coral").is_checkactive == "1",
      atelier_de_fotografia: services.find(s=>s.checkboxes == "atelier_de_fotografia").is_checkactive == "1",
      torneios_de_boccia: services.find(s=>s.checkboxes == "torneios_de_boccia").is_checkactive == "1",
      aulas_de_informatica: services.find(s=>s.checkboxes == "aulas_de_informatica").is_checkactive == "1",
//Comodidades
      blioteca: services.find(s=>s.checkboxes == "biblioteca").is_checkactive == "1",
      ginasio: services.find(s=>s.checkboxes == "ginasio").is_checkactive == "1",
      jardim: services.find(s=>s.checkboxes == "jardim").is_checkactive == "1",
      piscina: services.find(s=>s.checkboxes == "piscina").is_checkactive == "1",
      capela: services.find(s=>s.checkboxes == "capela").is_checkactive == "1",
      aceita_animais: services.find(s=>s.checkboxes == "aceita_animais").is_checkactive == "1",
      spa: services.find(s=>s.checkboxes == "spa").is_checkactive == "1",
      salao_de_festas: services.find(s=>s.checkboxes == "salao_de_festas").is_checkactive == "1",
      auditorio: services.find(s=>s.checkboxes == "auditorio").is_checkactive == "1",
      sala_de_actividades: services.find(s=>s.checkboxes == "sala_de_actividades").is_checkactive == "1",
      sala_de_cinema: services.find(s=>s.checkboxes == "sala_de_cinema").is_checkactive == "1",
      internet: services.find(s=>s.checkboxes == "internet").is_checkactive == "1",
      horta: services.find(s=>s.checkboxes == "horta").is_checkactive == "1",
      restaurante: services.find(s=>s.checkboxes == "restaurante").is_checkactive == "1",
      cafetaria: services.find(s=>s.checkboxes == "cafetaria").is_checkactive == "1",
      estacionamento: services.find(s=>s.checkboxes == "estacionamento").is_checkactive == "1",
      sala_de_fisioterapia: services.find(s=>s.checkboxes == "sala_de_fisioterapia").is_checkactive == "1",
      jacuzzi: services.find(s=>s.checkboxes == "jacuzzi").is_checkactive == "1",
      gabinete_de_estetica: services.find(s=>s.checkboxes == "gabinete_de_estetica").is_checkactive == "1",
      campo_de_tenis: services.find(s=>s.checkboxes == "campo_de_tenis").is_checkactive == "1",
      sala_de_costura: services.find(s=>s.checkboxes == "sala_de_costura").is_checkactive == "1",
      sala_de_massagens: services.find(s=>s.checkboxes == "sala_de_massagens").is_checkactive == "1",
      sala_de_culto: services.find(s=>s.checkboxes == "sala_de_culto").is_checkactive == "1",
//Acordos e Protocolos
      scml: services.find(s=>s.checkboxes == "scml").is_checkactive == "1",
      ssap: services.find(s=>s.checkboxes == "ssap").is_checkactive == "1",
      sti: services.find(s=>s.checkboxes == "sti").is_checkactive == "1",
      snqtb: services.find(s=>s.checkboxes == "snqtb").is_checkactive == "1",
//Unidades de Saúde
      hospital: services.find(s=>s.checkboxes == "hospital").is_checkactive == "1",
      centro_de_saude: services.find(s=>s.checkboxes == "centro_de_saude").is_checkactive == "1",
//Transportes Próximos
      autocarro: services.find(s=>s.checkboxes == "autocarro").is_checkactive == "1",
      comboio: services.find(s=>s.checkboxes == "comboio").is_checkactive == "1",
      metro: services.find(s=>s.checkboxes == "metro").is_checkactive == "1",
      praca_de_taxis: services.find(s=>s.checkboxes == "praca_de_taxis").is_checkactive == "1",
      barco: services.find(s=>s.checkboxes == "barco").is_checkactive == "1",
      aeroporto: services.find(s=>s.checkboxes == "aeroporto").is_checkactive == "1",
      electrico: services.find(s=>s.checkboxes == "electrico").is_checkactive == "1",
//Aeroportos de Portugal
      humberto_delgado_lisboa: services.find(s=>s.checkboxes == "humberto_delgado_lisboa").is_checkactive == "1",
      francisco_sa_carneiro_porto: services.find(s=>s.checkboxes == "francisco_sa_carneiro_porto").is_checkactive == "1",
      internacional_de_faro_algarve: services.find(s=>s.checkboxes == "internacional_de_faro_algarve").is_checkactive == "1",
      internacional_do_alentejo_beja: services.find(s=>s.checkboxes == "internacional_do_alentejo_beja").is_checkactive == "1",
//Aceita
      _65_anos: services.find(s=>s.checkboxes == "_65_anos").is_checkactive == "1",
      estrangeiros: services.find(s=>s.checkboxes == "estrangeiros").is_checkactive == "1",
      animais_de_estimacao: services.find(s=>s.checkboxes == "animais_de_estimacao").is_checkactive == "1",
      estadias_temporarias: services.find(s=>s.checkboxes == "estadias_temporarias").is_checkactive == "1",
      deficiencia_motora: services.find(s=>s.checkboxes == "deficiencia_motora").is_checkactive == "1",
      deficiencia_visual: services.find(s=>s.checkboxes == "deficiencia_visual").is_checkactive == "1",
//Interdito
      homens: services.find(s=>s.checkboxes == "homens").is_checkactive == "1",
      mulheres: services.find(s=>s.checkboxes == "mulheres").is_checkactive == "1",
//Outras Valências
      centro_de_dia: services.find(s=>s.checkboxes == "centro_de_dia").is_checkactive == "1",
      apoio_no_domicilio: services.find(s=>s.checkboxes == "apoio_no_domicilio").is_checkactive == "1",
      cuidados_continuados: services.find(s=>s.checkboxes == "cuidados_continuados").is_checkactive == "1",

//comboboxes
      alimentacao_e_hidratacao_cb: servicesComboboxes.find(s=>s.checkboxes == "alimentacao_e_hidratacao")?servicesComboboxes.find(s=>s.checkboxes == "alimentacao_e_hidratacao").value_id:null,
      quartos_individuais_cb: servicesComboboxes.find(s=>s.checkboxes == "quartos_individuais")?servicesComboboxes.find(s=>s.checkboxes == "quartos_individuais").value_id:null,
      suites_individuais_cb: servicesComboboxes.find(s=>s.checkboxes == "suites_individuais")?servicesComboboxes.find(s=>s.checkboxes == "suites_individuais").value_id:null,
      suites_duplas_cb: servicesComboboxes.find(s=>s.checkboxes == "suites_duplas")?servicesComboboxes.find(s=>s.checkboxes == "suites_duplas").value_id:null,
      apartamentos_cb: servicesComboboxes.find(s=>s.checkboxes == "apartamentos")?servicesComboboxes.find(s=>s.checkboxes == "apartamentos").value_id:null,
      esquizofrenia_cb: servicesComboboxes.find(s=>s.checkboxes == "esquizofrenia")?servicesComboboxes.find(s=>s.checkboxes == "esquizofrenia").value_id:null,
      psicomotricidade_cb: servicesComboboxes.find(s=>s.checkboxes == "psicomotricidade")?servicesComboboxes.find(s=>s.checkboxes == "psicomotricidade").value_id:null,
      terapia_de_snoezelen_cb: servicesComboboxes.find(s=>s.checkboxes == "terapia_de_snoezelen")?servicesComboboxes.find(s=>s.checkboxes == "terapia_de_snoezelen").value_id:null,
      ortopedia_cb: servicesComboboxes.find(s=>s.checkboxes == "ortopedia")?servicesComboboxes.find(s=>s.checkboxes == "ortopedia").value_id:null,
      acupuntura_cb: servicesComboboxes.find(s=>s.checkboxes == "acupuntura")?servicesComboboxes.find(s=>s.checkboxes == "acupuntura").value_id:null,
      medico_de_clinica_geral_cb: servicesComboboxes.find(s=>s.checkboxes == "medico_de_clinica_geral")?servicesComboboxes.find(s=>s.checkboxes == "medico_de_clinica_geral").value_id:null,
      enfermagem_cb: servicesComboboxes.find(s=>s.checkboxes == "enfermagem")?servicesComboboxes.find(s=>s.checkboxes == "enfermagem").value_id:null,
      neurologista_cb: servicesComboboxes.find(s=>s.checkboxes == "neurologista")?servicesComboboxes.find(s=>s.checkboxes == "neurologista").value_id:null,
      psicologo_cb: servicesComboboxes.find(s=>s.checkboxes == "psicologo")?servicesComboboxes.find(s=>s.checkboxes == "psicologo").value_id:null,
      fisioterapia_de_grupo_cb: servicesComboboxes.find(s=>s.checkboxes == "fisioterapia_de_grupo")?servicesComboboxes.find(s=>s.checkboxes == "fisioterapia_de_grupo").value_id:null,
      fisioterapia_personalizada_cb: servicesComboboxes.find(s=>s.checkboxes == "fisioterapia_personalizada")?servicesComboboxes.find(s=>s.checkboxes == "fisioterapia_personalizada").value_id:null,
      terapia_da_fala_cb: servicesComboboxes.find(s=>s.checkboxes == "terapia_da_fala")?servicesComboboxes.find(s=>s.checkboxes == "terapia_da_fala").value_id:null,
      terapia_ocupacional_cb: servicesComboboxes.find(s=>s.checkboxes == "terapia_ocupacional")?servicesComboboxes.find(s=>s.checkboxes == "terapia_ocupacional").value_id:null,
      terapia_ocupacional_cb: servicesComboboxes.find(s=>s.checkboxes == "terapia_ocupacional")?servicesComboboxes.find(s=>s.checkboxes == "terapia_ocupacional").value_id:null,
      animacao_sociocultural_cb: servicesComboboxes.find(s=>s.checkboxes == "animacao_sociocultural")?servicesComboboxes.find(s=>s.checkboxes == "animacao_sociocultural").value_id:null,
      atelier_de_costura_cb: servicesComboboxes.find(s=>s.checkboxes == "atelier_de_costura")?servicesComboboxes.find(s=>s.checkboxes == "atelier_de_costura").value_id:null,
      hidroterapia_cb: servicesComboboxes.find(s=>s.checkboxes == "hidroterapia")?servicesComboboxes.find(s=>s.checkboxes == "hidroterapia").value_id:null,
      musicoterapia_cb: servicesComboboxes.find(s=>s.checkboxes == "musicoterapia")?servicesComboboxes.find(s=>s.checkboxes == "musicoterapia").value_id:null,
      manutenção_fisica_cb: servicesComboboxes.find(s=>s.checkboxes == "manutenção_fisica")?servicesComboboxes.find(s=>s.checkboxes == "manutenção_fisica").value_id:null,
      jardinagem_cb: servicesComboboxes.find(s=>s.checkboxes == "jardinagem")?servicesComboboxes.find(s=>s.checkboxes == "jardinagem").value_id:null,
      estimulacao_cognitiva_cb: servicesComboboxes.find(s=>s.checkboxes == "estimulacao_cognitiva")?servicesComboboxes.find(s=>s.checkboxes == "estimulacao_cognitiva").value_id:null,
      terapia_snoezelen_cb: servicesComboboxes.find(s=>s.checkboxes == "terapia_snoezelen")?servicesComboboxes.find(s=>s.checkboxes == "terapia_snoezelen").value_id:null,
      expressão_plastica_cb: servicesComboboxes.find(s=>s.checkboxes == "expressão_plastica")?servicesComboboxes.find(s=>s.checkboxes == "expressão_plastica").value_id:null,
      passeios_e_visitas_culturais_cb: servicesComboboxes.find(s=>s.checkboxes == "passeios_e_visitas_culturais")?servicesComboboxes.find(s=>s.checkboxes == "passeios_e_visitas_culturais").value_id:null,
      atelier_de_escrita_criativa_cb: servicesComboboxes.find(s=>s.checkboxes == "atelier_de_escrita_criativa")?servicesComboboxes.find(s=>s.checkboxes == "atelier_de_escrita_criativa").value_id:null,
      celebracao_da_palavra_cb: servicesComboboxes.find(s=>s.checkboxes == "celebracao_da_palavra")?servicesComboboxes.find(s=>s.checkboxes == "celebracao_da_palavra").value_id:null,
      atelier_de_culinaria_cb: servicesComboboxes.find(s=>s.checkboxes == "atelier_de_culinaria")?servicesComboboxes.find(s=>s.checkboxes == "atelier_de_culinaria").value_id:null,
      aulas_de_danca_cb: servicesComboboxes.find(s=>s.checkboxes == "aulas_de_danca")?servicesComboboxes.find(s=>s.checkboxes == "aulas_de_danca").value_id:null,
      hidroginastica_cb: servicesComboboxes.find(s=>s.checkboxes == "hidroginastica")?servicesComboboxes.find(s=>s.checkboxes == "hidroginastica").value_id:null,
      atelier_de_teatro_cb: servicesComboboxes.find(s=>s.checkboxes == "atelier_de_teatro")?servicesComboboxes.find(s=>s.checkboxes == "atelier_de_teatro").value_id:null,
      bailes_cb: servicesComboboxes.find(s=>s.checkboxes == "bailes")?servicesComboboxes.find(s=>s.checkboxes == "bailes").value_id:null,
      aulas_de_motricidade_cb: servicesComboboxes.find(s=>s.checkboxes == "aulas_de_motricidade")?servicesComboboxes.find(s=>s.checkboxes == "aulas_de_motricidade").value_id:null,
      hipoterapia_cb: servicesComboboxes.find(s=>s.checkboxes == "hipoterapia")?servicesComboboxes.find(s=>s.checkboxes == "hipoterapia").value_id:null,
      expressao_musical_cb: servicesComboboxes.find(s=>s.checkboxes == "expressao_musical")?servicesComboboxes.find(s=>s.checkboxes == "expressao_musical").value_id:null,
      hospital_cb: servicesComboboxes.find(s=>s.checkboxes == "hospital")?servicesComboboxes.find(s=>s.checkboxes == "hospital").value_id:null,
      centro_de_saude_cb: servicesComboboxes.find(s=>s.checkboxes == "centro_de_saude")?servicesComboboxes.find(s=>s.checkboxes == "centro_de_saude").value_id:null,
      autocarro_cb: servicesComboboxes.find(s=>s.checkboxes == "autocarro")?servicesComboboxes.find(s=>s.checkboxes == "autocarro").value_id:null,
      comboio_cb: servicesComboboxes.find(s=>s.checkboxes == "comboio")?servicesComboboxes.find(s=>s.checkboxes == "comboio").value_id:null,
      metro_cb: servicesComboboxes.find(s=>s.checkboxes == "metro")?servicesComboboxes.find(s=>s.checkboxes == "metro").value_id:null,
      praca_de_taxis_cb: servicesComboboxes.find(s=>s.checkboxes == "praca_de_taxis")?servicesComboboxes.find(s=>s.checkboxes == "praca_de_taxis").value_id:null,
      barco_cb: servicesComboboxes.find(s=>s.checkboxes == "barco")?servicesComboboxes.find(s=>s.checkboxes == "barco").value_id:null,
      aeroporto_cb: servicesComboboxes.find(s=>s.checkboxes == "aeroporto")?servicesComboboxes.find(s=>s.checkboxes == "aeroporto").value_id:null,
      electrico_cb: servicesComboboxes.find(s=>s.checkboxes == "electrico")?servicesComboboxes.find(s=>s.checkboxes == "electrico").value_id:null,
      humberto_delgado_lisboa_cb: servicesComboboxes.find(s=>s.checkboxes == "humberto_delgado_lisboa")?servicesComboboxes.find(s=>s.checkboxes == "humberto_delgado_lisboa").value_id:null,
      francisco_sa_carneiro_porto_cb: servicesComboboxes.find(s=>s.checkboxes == "francisco_sa_carneiro_porto")?servicesComboboxes.find(s=>s.checkboxes == "francisco_sa_carneiro_porto").value_id:null,
      internacional_de_faro_algarve_cb: servicesComboboxes.find(s=>s.checkboxes == "internacional_de_faro_algarve")?servicesComboboxes.find(s=>s.checkboxes == "internacional_de_faro_algarve").value_id:null,
      internacional_do_alentejo_beja_cb: servicesComboboxes.find(s=>s.checkboxes == "internacional_do_alentejo_beja")?servicesComboboxes.find(s=>s.checkboxes == "internacional_do_alentejo_beja").value_id:null,
      _65_anos_cb: servicesComboboxes.find(s=>s.checkboxes == "_65_anos")?servicesComboboxes.find(s=>s.checkboxes == "_65_anos").value_id:null,
      estrangeiros_cb: servicesComboboxes.find(s=>s.checkboxes == "estrangeiros")?servicesComboboxes.find(s=>s.checkboxes == "estrangeiros").value_id:null,
    }}
    onSubmit={handleSubmitting(onSubmit)}
    validationSchema={validationSchema}
    validateOnChange={false}
    validateOnBlur={false}
    render={({
      values,
      //required,
      handleSubmit,
      setFieldValue,
      setFieldTouched,
    }) => {
      return (
        <form onSubmit={handleSubmit}>
          <div className="servicesTitle" style={{ fontWeight: "bold" }}>
            {" "}
            Tipo{" "}
          </div>
          <Grid item md={12} className="checkboxAlign">
            <Grid item xs={3}>
              <Field
                name="erpi"
                Label={{ label: "ERPI" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.erpi}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="ucci"
                Label={{ label: "UCCI" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.ucci}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="ucrm"
                Label={{ label: "UCRM" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.ucrm}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="hotel"
                Label={{ label: "Hotel" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.hotel}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="al"
                Label={{ label: "AL" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.al}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="casa_particular"
                Label={{ label: "Casa Particular" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.casa_particular}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="cohousing"
                Label={{ label: "Cohousing" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.cohousing}
              />
            </Grid>
          </Grid>
          <div className="servicesTitle" style={{ fontWeight: "bold" }}>
            {" "}
            Destinatários{" "}
          </div>
          <Grid item md={12} className="checkboxAlign">
            <Grid item xs={3}>
              <Field
                name="independentes"
                Label={{ label: "Independentes" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.independentes}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="dependentes"
                Label={{ label: "Dependentes" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.dependentes}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="muito_dependentes"
                Label={{ label: "Muito Dependentes" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.muito_dependentes}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="acamados"
                Label={{ label: "Acamados" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.acamados}
              />
            </Grid>
          </Grid>
          <div className="servicesTitle" style={{ fontWeight: "bold" }}>
            {" "}
            Serviços de Base{" "}
          </div>
          <Grid item md={12} className="checkboxAlign">
            <Grid item xs={3}>
              <Field
                name="alojamento_e_conforto"
                Label={{ label: "Alojamento e conforto" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.alojamento_e_conforto}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="higiene_e_apresentacao"
                Label={{ label: "Higiene e apresentação" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.higiene_e_apresentacao}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="apoio_nas_actividades_diarias"
                Label={{ label: "Apoio nas actividades diárias" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.apoio_nas_actividades_diarias}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="tratamento_de_roupa"
                Label={{ label: "Tratamento de roupa" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.tratamento_de_roupa}
              />
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="alimentacao_e_hidratacao"
                Label={{ label: "Alimentação e hidratação" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.alimentacao_e_hidratacao}
              />
              {values.alimentacao_e_hidratacao === "0" &&
                (values.alimentacao_e_hidratacao_cb = null)}
              {values.alimentacao_e_hidratacao === "1" && (
                <Field
                  name="alimentacao_e_hidratacao_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={
                    servicos_de_base_alimentacao_e_hidratacaoOptionsPromise
                  }
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.alimentacao_e_hidratacao_cb}
                />
              )}
            </Grid>
          </Grid>
          <div className="servicesTitle" style={{ fontWeight: "bold" }}>
            {" "}
            Tipos de Alojamento{" "}
          </div>
          <Grid item md={12} className="checkboxAlign">
            <Grid item xs={3}>
              <Field
                name="quartos_duplos"
                Label={{ label: "Quartos Duplos" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.quartos_duplos}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="quartos_triplos"
                Label={{ label: "Quartos Triplos" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.quartos_triplos}
              />
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="quartos_individuais"
                Label={{ label: "Quartos Individuais" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.quartos_individuais}
              />
              {values.quartos_individuais === "0" &&
                (values.quartos_individuais_cb = null)}
              {values.quartos_individuais === "1" && (
                <Field
                  name="quartos_individuais_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={
                    tipos_de_alojamento_quartos_individuaisOptionsPromise
                  }
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.quartos_individuais_cb}
                />
              )}
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="suites_individuais"
                Label={{ label: "Suites Individuais" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.suites_individuais}
              />
              {values.suites_individuais === "0" &&
                (values.suites_individuais_cb = null)}
              {values.suites_individuais === "1" && (
                <Field
                  name="suites_individuais_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={
                    tipos_de_alojamento_suites_individuaisOptionsPromise
                  }
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.suites_individuais_cb}
                />
              )}
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="suites_duplas"
                Label={{ label: "Suites Duplas" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.suites_duplas}
              />
              {values.suites_duplas === "0" && (values.suites_duplas_cb = null)}
              {values.suites_duplas === "1" && (
                <Field
                  name="suites_duplas_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={
                    tipos_de_alojamento_suites_duplasOptionsPromise
                  }
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.suites_duplas_cb}
                />
              )}
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="apartamentos"
                Label={{ label: "Apartamentos" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.apartamentos}
              />
              {values.apartamentos === "0" && (values.apartamentos_cb = null)}
              {values.apartamentos === "1" && (
                <Field
                  name="apartamentos_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={
                    tipos_de_alojamento_apartamentosOptionsPromise
                  }
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.apartamentos_cb}
                />
              )}
            </Grid>
            <Grid item xs={3}>
              <Field
                name="moradias_t0"
                Label={{ label: "Moradias T0" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.moradias_t0}
              />
            </Grid>
          </Grid>
          <div className="servicesTitle" style={{ fontWeight: "bold" }}>
            {" "}
            Detalhes nos quartos{" "}
          </div>
          <Grid item md={12} className="checkboxAlign">
            <Grid item xs={3}>
              <Field
                name="aquecimento_central"
                Label={{ label: "Aquecimento central" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.aquecimento_central}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="televisao_por_cabo"
                Label={{ label: "Televisão por cabo" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.televisao_por_cabo}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="camas_articuladas"
                Label={{ label: "Camas articuladas" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.camas_articuladas}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="colchoes_anti_escaras"
                Label={{ label: "Colchões anti-escaras" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.colchoes_anti_escaras}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="sistema_de_chamada"
                Label={{ label: "Sistema de chamada" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.sistema_de_chamada}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="ar_condicionado"
                Label={{ label: "Ar condicionado" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.ar_condicionado}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="cofre_individual"
                Label={{ label: "Cofre Individual" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.cofre_individual}
              />
            </Grid>
          </Grid>
          <div className="servicesTitle" style={{ fontWeight: "bold" }}>
            {" "}
            Segurança e Acessibilidade{" "}
          </div>
          <Grid item md={12} className="checkboxAlign">
            <Grid item xs={3}>
              <Field
                name="plataforma_elevatoria"
                Label={{ label: "Plataforma Elevatória" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.plataforma_elevatoria}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="ajudas_tecnicas"
                Label={{ label: "Ajudas Técnicas" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.ajudas_tecnicas}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="elevador_de_servicos"
                Label={{ label: "Elevador de Serviços" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.elevador_de_servicos}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="cadeira_elevatoria"
                Label={{ label: "Cadeira Elevatória" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.cadeira_elevatoria}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="banho_geriatrico"
                Label={{ label: "Banho Geriátrico" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.banho_geriatrico}
              />
            </Grid>
          </Grid>
          <div className="servicesTitle" style={{ fontWeight: "bold" }}>
            {" "}
            Patologias Aceites{" "}
          </div>
          <Grid item md={12} className="checkboxAlign">
            <Grid item xs={3}>
              <Field
                name="alzheimer"
                Label={{ label: "Alzheimer" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.alzheimer}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="parkinson"
                Label={{ label: "Parkinson" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.parkinson}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="demencia"
                Label={{ label: "Demência" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.demencia}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="hiv"
                Label={{ label: "HIV" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.hiv}
              />
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="esquizofrenia"
                Label={{ label: "Esquizofrenia" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.esquizofrenia}
              />
              {values.esquizofrenia === "0" && (values.esquizofrenia_cb = null)}
              {values.esquizofrenia === "1" && (
                <Field
                  name="esquizofrenia_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={
                    patologias_aceites_esquizofreniaOptionsPromise
                  }
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.esquizofrenia_cb}
                />
              )}
            </Grid>
            <Grid item xs={3}>
              <Field
                name="alcoolismo"
                Label={{ label: "Alcoolismo" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.alcoolismo}
              />
            </Grid>
          </Grid>
          <div className="servicesTitle" style={{ fontWeight: "bold" }}>
            {" "}
            Cuidados de Saúde{" "}
          </div>
          <Grid item md={12} className="checkboxAlign">
            <Grid item xs={3} className="comboCheck">
              <Field
                name="psicomotricidade"
                Label={{ label: "Psicomotricidade" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.psicomotricidade}
              />
              {values.psicomotricidade === "0" &&
                (values.psicomotricidade_cb = null)}
              {values.psicomotricidade === "1" && (
                <Field
                  name="psicomotricidade_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={
                    cuidados_de_saude_psicomotricidadeOptionsPromise
                  }
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.psicomotricidade_cb}
                />
              )}
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="terapia_de_snoezelen"
                Label={{ label: "Terapia de Snoezelen" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.terapia_de_snoezelen}
              />
              {values.terapia_de_snoezelen === "0" &&
                (values.terapia_de_snoezelen_cb = null)}
              {values.terapia_de_snoezelen === "1" && (
                <Field
                  name="terapia_de_snoezelen_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={
                    cuidados_de_saude_terapia_de_snoezelenOptionsPromise
                  }
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.terapia_de_snoezelen_cb}
                />
              )}
            </Grid>
            <Grid item xs={3}>
              <Field
                name="nutricionista"
                Label={{ label: "Nutricionista" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.nutricionista}
              />
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="ortopedia"
                Label={{ label: "Ortopedia" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.ortopedia}
              />
              {values.ortopedia === "0" && (values.ortopedia_cb = null)}
              {values.ortopedia === "1" && (
                <Field
                  name="ortopedia_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={cuidados_de_saude_ortopediaOptionsPromise}
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.ortopedia_cb}
                />
              )}
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="acupuntura"
                Label={{ label: "Acupuntura" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.acupuntura}
              />
              {values.acupuntura === "0" && (values.acupuntura_cb = null)}
              {values.acupuntura === "1" && (
                <Field
                  name="acupuntura_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={cuidados_de_saude_acupunturaOptionsPromise}
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.acupuntura_cb}
                />
              )}
            </Grid>
            <Grid item xs={3}>
              <Field
                name="psicogerontologia"
                Label={{ label: "Psicogerontologia" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.psicogerontologia}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="terapia_de_reminiscencia"
                Label={{ label: "Terapia de Reminiscência" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.terapia_de_reminiscencia}
              />
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="medico_de_clinica_geral"
                Label={{ label: "Médico de Clínica Geral" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.medico_de_clinica_geral}
              />
              {values.medico_de_clinica_geral === "0" &&
                (values.medico_de_clinica_geral_cb = null)}
              {values.medico_de_clinica_geral === "1" && (
                <Field
                  name="medico_de_clinica_geral_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={
                    cuidados_de_saude_medico_de_clinica_geralOptionsPromise
                  }
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.medico_de_clinica_geral_cb}
                />
              )}
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="enfermagem"
                Label={{ label: "Enfermagem" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.enfermagem}
              />
              {values.enfermagem === "0" && (values.enfermagem_cb = null)}
              {values.enfermagem === "1" && (
                <Field
                  name="enfermagem_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={cuidados_de_saude_enfermagemOptionsPromise}
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.enfermagem_cb}
                />
              )}
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="neurologista"
                Label={{ label: "Neurologista" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.neurologista}
              />
              {values.neurologista === "0" && (values.neurologista_cb = null)}
              {values.neurologista === "1" && (
                <Field
                  name="neurologista_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={cuidados_de_saude_neurologistaOptionsPromise}
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.neurologista_cb}
                />
              )}
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="psicologo"
                Label={{ label: "Psicólogo" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.psicologo}
              />
              {values.psicologo === "0" && (values.psicologo_cb = null)}
              {values.psicologo === "1" && (
                <Field
                  name="psicologo_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={cuidados_de_saude_psicologoOptionsPromise}
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.psicologo_cb}
                />
              )}
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="fisioterapia_de_grupo"
                Label={{ label: "Fisioterapia de Grupo" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.fisioterapia_de_grupo}
              />
              {values.fisioterapia_de_grupo === "0" &&
                (values.fisioterapia_de_grupo_cb = null)}
              {values.fisioterapia_de_grupo === "1" && (
                <Field
                  name="fisioterapia_de_grupo_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={
                    cuidados_de_saude_fisioterapia_de_grupoOptionsPromise
                  }
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.fisioterapia_de_grupo_cb}
                />
              )}
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="fisioterapia_personalizada"
                Label={{ label: "Fisioterapia Personalizada" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.fisioterapia_personalizada}
              />
              {values.fisioterapia_personalizada === "0" &&
                (values.fisioterapia_personalizada_cb = null)}
              {values.fisioterapia_personalizada === "1" && (
                <Field
                  name="fisioterapia_personalizada_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={
                    cuidados_de_saude_fisioterapia_personalizadaOptionsPromise
                  }
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.fisioterapia_personalizada_cb}
                />
              )}
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="terapia_da_fala"
                Label={{ label: "Terapia da Fala" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.terapia_da_fala}
              />
              {values.terapia_da_fala === "0" &&
                (values.terapia_da_fala_cb = null)}
              {values.terapia_da_fala === "1" && (
                <Field
                  name="terapia_da_fala_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={
                    cuidados_de_saude_terapia_da_falaOptionsPromise
                  }
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.terapia_da_fala_cb}
                />
              )}
            </Grid>
            <Grid item xs={3}>
              <Field
                name="psiquiatra"
                Label={{ label: "Psiquiatra" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.psiquiatra}
              />
            </Grid>
          </Grid>
          <div className="servicesTitle" style={{ fontWeight: "bold" }}>
            {" "}
            Ofertas{" "}
          </div>
          <Grid item md={12} className="checkboxAlign">
            <Grid item xs={3}>
              <Field
                name="material_de_incontinencia"
                Label={{ label: "Material de Incontinência" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.material_de_incontinencia}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="material_de_enfermagem"
                Label={{ label: "Material de Enfermagem" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.material_de_enfermagem}
              />
            </Grid>
          </Grid>
          <div className="servicesTitle" style={{ fontWeight: "bold" }}>
            {" "}
            Serviços Opcionais{" "}
          </div>
          <Grid item md={12} className="checkboxAlign">
            <Grid item xs={3}>
              <Field
                name="barbeiro"
                Label={{ label: "Barbeiro" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.barbeiro}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="yoga"
                Label={{ label: "Yoga" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.yoga}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="lavandaria"
                Label={{ label: "Lavandaria" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.lavandaria}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="acompanhamento"
                Label={{ label: "Acompanhamento" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.acompanhamento}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="transporte"
                Label={{ label: "Transporte" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.transporte}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="cabeleireiro"
                Label={{ label: "Cabeleireiro" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.cabeleireiro}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="manicure"
                Label={{ label: "Manicure" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.manicure}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="podologista"
                Label={{ label: "Podologista" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.podologista}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="massagem"
                Label={{ label: "Massagem" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.massagem}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="reiki"
                Label={{ label: "Reiki" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.reiki}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="pilates"
                Label={{ label: "Pilates" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.pilates}
              />
            </Grid>
          </Grid>
          <div className="servicesTitle" style={{ fontWeight: "bold" }}>
            {" "}
            Ocupação{" "}
          </div>
          <Grid item md={12} className="checkboxAlign">
            <Grid item xs={3} className="comboCheck">
              <Field
                name="terapia_ocupacional"
                Label={{ label: "Terapia Ocupacional" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.terapia_ocupacional}
              />
              {values.terapia_ocupacional === "0" &&
                (values.terapia_ocupacional_cb = null)}
              {values.terapia_ocupacional === "1" && (
                <Field
                  name="terapia_ocupacional_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={ocupacao_terapia_ocupacionalOptionsPromise}
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.terapia_ocupacional_cb}
                />
              )}
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="animacao_sociocultural"
                Label={{ label: "Animação Sociocultural" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.animacao_sociocultural}
              />
              {values.animacao_sociocultural === "0" &&
                (values.animacao_sociocultural_cb = null)}
              {values.animacao_sociocultural === "1" && (
                <Field
                  name="animacao_sociocultural_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={ocupacao_animacao_socioculturalOptionsPromise}
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.ocupacao_animacao_sociocultural}
                />
              )}
            </Grid>
          </Grid>
          <div className="servicesTitle" style={{ fontWeight: "bold" }}>
            {" "}
            Plano de Actividades{" "}
          </div>
          <Grid item md={12} className="checkboxAlign">
            <Grid item xs={3} className="comboCheck">
              <Field
                name="atelier_de_costura"
                Label={{ label: "Atelier de Costura" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.atelier_de_costura}
              />
              {values.atelier_de_costura === "0" &&
                (values.atelier_de_costura_cb = null)}
              {values.atelier_de_costura === "1" && (
                <Field
                  name="atelier_de_costura_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={
                    plano_de_atividades_atelier_de_costuraOptionsPromise
                  }
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.atelier_de_costura_cb}
                />
              )}
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="hidroterapia"
                Label={{ label: "Hidroterapia" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.hidroterapia}
              />
              {values.hidroterapia === "0" && (values.hidroterapia_cb = null)}
              {values.hidroterapia === "1" && (
                <Field
                  name="hidroterapia_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={
                    plano_de_atividades_hidroterapiaOptionsPromise
                  }
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.hidroterapia_cb}
                />
              )}
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="musicoterapia"
                Label={{ label: "Musicoterapia" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.musicoterapia}
              />
              {values.musicoterapia === "0" && (values.musicoterapia_cb = null)}
              {values.musicoterapia === "1" && (
                <Field
                  name="musicoterapia_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={
                    plano_de_atividades_musicoterapiaOptionsPromise
                  }
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.musicoterapia_cb}
                />
              )}
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="manutenção_fisica"
                Label={{ label: "Manutenção Física" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.manutenção_fisica}
              />
              {values.manutenção_fisica === "0" &&
                (values.manutenção_fisica_cb = null)}
              {values.manutenção_fisica === "1" && (
                <Field
                  name="manutenção_fisica_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={
                    plano_de_atividades_manutencao_fisicaOptionsPromise
                  }
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.manutenção_fisica_cb}
                />
              )}
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="jardinagem"
                Label={{ label: "Jardinagem" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.jardinagem}
              />
              {values.jardinagem === "0" && (values.jardinagem_cb = null)}
              {values.jardinagem === "1" && (
                <Field
                  name="jardinagem_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={plano_de_atividades_jardinagemOptionsPromise}
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.jardinagem_cb}
                />
              )}
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="estimulacao_cognitiva"
                Label={{ label: "Estimulação Cognitiva" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.estimulacao_cognitiva}
              />
              {values.estimulacao_cognitiva === "0" &&
                (values.estimulacao_cognitiva_cb = null)}
              {values.estimulacao_cognitiva === "1" && (
                <Field
                  name="estimulacao_cognitiva_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={
                    plano_de_atividades_estimulação_cognitivaOptionsPromise
                  }
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.estimulacao_cognitiva_cb}
                />
              )}
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="terapia_snoezelen"
                Label={{ label: "Terapia Snoezelen" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.terapia_snoezelen}
              />
              {values.terapia_snoezelen === "0" &&
                (values.terapia_snoezelen_cb = null)}
              {values.terapia_snoezelen === "1" && (
                <Field
                  name="terapia_snoezelen_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={
                    plano_de_atividades_terapia_snoezelenOptionsPromise
                  }
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.terapia_snoezelen_cb}
                />
              )}
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="expressão_plastica"
                Label={{ label: "Expressão Plástica" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.expressão_plastica}
              />
              {values.expressão_plastica === "0" &&
                (values.expressão_plastica_cb = null)}
              {values.expressão_plastica === "1" && (
                <Field
                  name="expressão_plastica_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={
                    plano_de_atividades_expressao_plasticaOptionsPromise
                  }
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.expressão_plastica_cb}
                />
              )}
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="passeios_e_visitas_culturais"
                Label={{ label: "Passeios e Visitas Culturais" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.passeios_e_visitas_culturais}
              />
              {values.passeios_e_visitas_culturais === "0" &&
                (values.passeios_e_visitas_culturais_cb = null)}
              {values.passeios_e_visitas_culturais === "1" && (
                <Field
                  name="passeios_e_visitas_culturais_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={
                    plano_de_atividades_passeios_e_visitas_culturaisOptionsPromise
                  }
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.passeios_e_visitas_culturais_cb}
                />
              )}
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="novas_tecnologias"
                Label={{ label: "Novas Tecnologias" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.novas_tecnologias}
              />
              {values.novas_tecnologias === "0" &&
                (values.novas_tecnologias_cb = null)}
              {values.novas_tecnologias === "1" && (
                <Field
                  name="novas_tecnologias_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={
                    plano_de_atividades_novas_tecnologiasOptionsPromise
                  }
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.novas_tecnologias_cb}
                />
              )}
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="atelier_de_escrita_criativa"
                Label={{ label: "Atelier de Escrita Criativa" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.atelier_de_escrita_criativa}
              />
              {values.atelier_de_escrita_criativa === "0" &&
                (values.atelier_de_escrita_criativa_cb = null)}
              {values.atelier_de_escrita_criativa === "1" && (
                <Field
                  name="atelier_de_escrita_criativa_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={
                    plano_de_atividades_atelier_de_escrita_criativaOptionsPromise
                  }
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.atelier_de_escrita_criativa_cb}
                />
              )}
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="celebracao_da_palavra"
                Label={{ label: "Celebração da Palavra" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.celebracao_da_palavra}
              />
              {values.celebracao_da_palavra === "0" &&
                (values.celebracao_da_palavra_cb = null)}
              {values.celebracao_da_palavra === "1" && (
                <Field
                  name="celebracao_da_palavra_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={
                    plano_de_atividades_celebracao_da_palavraOptionsPromise
                  }
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.celebracao_da_palavra_cb}
                />
              )}
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="atelier_de_culinaria"
                Label={{ label: "Atelier de Culinária" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.atelier_de_culinaria}
              />
              {values.atelier_de_culinaria === "0" &&
                (values.atelier_de_culinaria_cb = null)}
              {values.atelier_de_culinaria === "1" && (
                <Field
                  name="atelier_de_culinaria_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={
                    plano_de_atividades_atelier_de_culinariaOptionsPromise
                  }
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.atelier_de_culinaria_cb}
                />
              )}
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="aulas_de_danca"
                Label={{ label: "Aulas de Dança" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.aulas_de_danca}
              />
              {values.aulas_de_danca === "0" &&
                (values.aulas_de_danca_cb = null)}
              {values.aulas_de_danca === "1" && (
                <Field
                  name="aulas_de_danca_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={
                    plano_de_atividades_aulas_de_dancaOptionsPromise
                  }
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.aulas_de_danca_cb}
                />
              )}
            </Grid>
            <Grid item xs={3}>
              <Field
                name="estimulacao_funcional"
                Label={{ label: "Estimulação Funcional" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.estimulacao_funcional}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="terapia_assistida_por_animais"
                Label={{ label: "Terapia Assistida por Animais" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.terapia_assistida_por_animais}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="atelier_de_leitura"
                Label={{ label: "Atelier de Leitura" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.atelier_de_leitura}
              />
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="hidroginastica"
                Label={{ label: "Hidroginástica" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.hidroginastica}
              />
              {values.hidroginastica === "0" &&
                (values.hidroginastica_cb = null)}
              {values.hidroginastica === "1" && (
                <Field
                  name="hidroginastica_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={
                    plano_de_atividades_hidroginasticaOptionsPromise
                  }
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.hidroginastica_cb}
                />
              )}
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="atelier_de_teatro"
                Label={{ label: "Atelier de Teatro" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.atelier_de_teatro}
              />
              {values.atelier_de_teatro === "0" &&
                (values.atelier_de_teatro_cb = null)}
              {values.atelier_de_teatro === "1" && (
                <Field
                  name="atelier_de_teatro_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={
                    plano_de_atividades_atelier_de_teatroOptionsPromise
                  }
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.atelier_de_teatro_cb}
                />
              )}
            </Grid>
            <Grid item xs={3}>
              <Field
                name="estimulacao_sensorial"
                Label={{ label: "Estimulação Sensorial" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.estimulacao_sensorial}
              />
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="bailes"
                Label={{ label: "Bailes" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.bailes}
              />
              {values.bailes === "0" && (values.bailes_cb = null)}
              {values.bailes === "1" && (
                <Field
                  name="bailes_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={plano_de_atividades_bailesOptionsPromise}
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.bailes_cb}
                />
              )}
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="aulas_de_motricidade"
                Label={{ label: "Aulas de Motricidade" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.aulas_de_motricidade}
              />
              {values.aulas_de_motricidade === "0" &&
                (values.aulas_de_motricidade_cb = null)}
              {values.aulas_de_motricidade === "1" && (
                <Field
                  name="aulas_de_motricidade_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={
                    plano_de_atividades_aulas_de_motricidadeOptionsPromise
                  }
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.aulas_de_motricidade_cb}
                />
              )}
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="hipoterapia"
                Label={{ label: "Hipoterapia" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.hipoterapia}
              />
              {values.hipoterapia === "0" && (values.hipoterapia_cb = null)}
              {values.hipoterapia === "1" && (
                <Field
                  name="hipoterapia_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={plano_de_atividades_hipoterapiaOptionsPromise}
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.hipoterapia_cb}
                />
              )}
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="expressao_musical"
                Label={{ label: "Expressão Musical" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.expressao_musical}
              />
              {values.expressao_musical === "0" &&
                (values.expressao_musical_cb = null)}
              {values.expressao_musical === "1" && (
                <Field
                  name="expressao_musical_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={
                    plano_de_atividades_expressao_musicalOptionsPromise
                  }
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.expressao_musical_cb}
                />
              )}
            </Grid>
            <Grid item xs={3}>
              <Field
                name="canto_coral"
                Label={{ label: "Canto Coral" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.canto_coral}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="atelier_de_fotografia"
                Label={{ label: "Atelier de Fotografia" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.atelier_de_fotografia}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="torneios_de_boccia"
                Label={{ label: "Torneios de Bóccia" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.torneios_de_boccia}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="aulas_de_informatica"
                Label={{ label: "Aulas de Informática" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.aulas_de_informatica}
              />
            </Grid>
          </Grid>
          <div className="servicesTitle" style={{ fontWeight: "bold" }}>
            {" "}
            Comodidades{" "}
          </div>
          <Grid item md={12} className="checkboxAlign">
            <Grid item xs={3}>
              <Field
                name="biblioteca"
                Label={{ label: "Biblioteca" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.biblioteca}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="ginasio"
                Label={{ label: "Ginásio" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.ginasio}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="jardim"
                Label={{ label: "Jardim" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.jardim}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="piscina"
                Label={{ label: "Piscina" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.piscina}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="capela"
                Label={{ label: "Capela" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.capela}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="aceita_animais"
                Label={{ label: "Aceita animais" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.aceita_animais}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="spa"
                Label={{ label: "SPA" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.spa}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="salao_de_festas"
                Label={{ label: "Salão de festas" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.salao_de_festas}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="auditorio"
                Label={{ label: "Auditório" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.auditorio}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="sala_de_actividades"
                Label={{ label: "Sala de Actividades" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.sala_de_actividades}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="sala_de_cinema"
                Label={{ label: "Sala de Cinema" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.sala_de_cinema}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="internet"
                Label={{ label: "Internet" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.internet}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="horta"
                Label={{ label: "Horta" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.horta}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="restaurante"
                Label={{ label: "Restaurante" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.restaurante}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="cafetaria"
                Label={{ label: "Cafetaria" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.cafetaria}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="estacionamento"
                Label={{ label: "Estacionamento" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.estacionamento}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="sala_de_fisioterapia"
                Label={{ label: "Sala de Fisioterapia" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.sala_de_fisioterapia}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="jacuzzi"
                Label={{ label: "Jacuzzi" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.jacuzzi}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="gabinete_de_estetica"
                Label={{ label: "Gabinete de Estética" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.gabinete_de_estetica}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="campo_de_tenis"
                Label={{ label: "Campo de Ténis" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.campo_de_tenis}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="sala_de_costura"
                Label={{ label: "Sala de Costura" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.sala_de_costura}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="sala_de_massagens"
                Label={{ label: "Sala de Massagens" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.sala_de_massagens}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="sala_de_culto"
                Label={{ label: "Sala de Culto" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.sala_de_culto}
              />
            </Grid>
          </Grid>
          <div className="servicesTitle" style={{ fontWeight: "bold" }}>
            {" "}
            Acordos e Protocolos{" "}
          </div>
          <Grid item md={12} className="checkboxAlign">
            <Grid item xs={3}>
              <Field
                name="scml"
                Label={{ label: "SCML" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.scml}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="ssap"
                Label={{ label: "SSAP" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.ssap}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="sti"
                Label={{ label: "STI" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.sti}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="snqtb"
                Label={{ label: "SNQTB" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.snqtb}
              />
            </Grid>
          </Grid>
          <div className="servicesTitle" style={{ fontWeight: "bold" }}>
            {" "}
            Unidades de Saúde{" "}
          </div>
          <Grid item md={12} className="checkboxAlign">
            <Grid item xs={3} className="comboCheck">
              <Field
                name="hospital"
                Label={{ label: "Hospital" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.hospital}
              />
              {values.hospital === "0" && (values.hospital_cb = null)}
              {values.hospital === "1" && (
                <Field
                  name="hospital_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={health_unities_hospitalOptionsPromise}
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.hospital_cb}
                />
              )}
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="centro_de_saude"
                Label={{ label: "Centro de Saúde" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.centro_de_saude}
              />
              {values.centro_de_saude === "0" &&
                (values.centro_de_saude_cb = null)}
              {values.centro_de_saude === "1" && (
                <Field
                  name="centro_de_saude_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={health_unities_centro_de_saudeOptionsPromise}
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.centro_de_saude_cb}
                />
              )}
            </Grid>
          </Grid>
          <div className="servicesTitle" style={{ fontWeight: "bold" }}>
            {" "}
            Transportes Próximos{" "}
          </div>
          <Grid item md={12} className="checkboxAlign">
            <Grid item xs={3} className="comboCheck">
              <Field
                name="autocarro"
                Label={{ label: "Autocarro" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.autocarro}
              />
              {values.autocarro === "0" && (values.autocarro_cb = null)}
              {values.autocarro === "1" && (
                <Field
                  name="autocarro_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={transportes_proximos_autocarroOptionsPromise}
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.autocarro_cb}
                />
              )}
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="comboio"
                Label={{ label: "Comboio" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.comboio}
              />
              {values.comboio === "0" && (values.comboio_cb = null)}
              {values.comboio === "1" && (
                <Field
                  name="comboio_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={transportes_proximos_comboioOptionsPromise}
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.comboio_cb}
                />
              )}
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="metro"
                Label={{ label: "Metro" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.metro}
              />
              {values.metro === "0" && (values.metro_cb = null)}
              {values.metro === "1" && (
                <Field
                  name="metro_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={transportes_proximos_metroOptionsPromise}
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.metro_cb}
                />
              )}
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="praca_de_taxis"
                Label={{ label: "Praça de Táxis" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.praca_de_taxis}
              />
              {values.praca_de_taxis === "0" &&
                (values.praca_de_taxis_cb = null)}
              {values.praca_de_taxis === "1" && (
                <Field
                  name="praca_de_taxis_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={
                    transportes_proximos_praca_de_taxisOptionsPromise
                  }
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.praca_de_taxis_cb}
                />
              )}
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="barco"
                Label={{ label: "Barco" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.barco}
              />
              {values.barco === "0" && (values.barco_cb = null)}
              {values.barco === "1" && (
                <Field
                  name="barco_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={transportes_proximos_barcoOptionsPromise}
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.barco_cb}
                />
              )}
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="aeroporto"
                Label={{ label: "Aeroporto" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.aeroporto}
              />
              {values.aeroporto === "0" && (values.aeroporto_cb = null)}
              {values.aeroporto === "1" && (
                <Field
                  name="aeroporto_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={transportes_proximos_aeroportoOptionsPromise}
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.aeroporto_cb}
                />
              )}
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="electrico"
                Label={{ label: "Eléctrico" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.electrico}
              />
              {values.electrico === "0" && (values.electrico_cb = null)}
              {values.electrico === "1" && (
                <Field
                  name="electrico_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={transportes_proximos_eletricoOptionsPromise}
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.electrico_cb}
                />
              )}
            </Grid>
          </Grid>
          <div className="servicesTitle" style={{ fontWeight: "bold" }}>
            Aeroportos de Portugal{" "}
          </div>
          <Grid item md={12} className="checkboxAlign">
            <Grid item xs={3} className="comboCheck">
              <Field
                name="humberto_delgado_lisboa"
                Label={{ label: "Humberto Delgado (Lisboa)" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.humberto_delgado_lisboa}
              />
              {values.humberto_delgado_lisboa === "0" &&
                (values.humberto_delgado_lisboa_cb = null)}
              {values.humberto_delgado_lisboa === "1" && (
                <Field
                  name="humberto_delgado_lisboa_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={
                    aeroportos_de_portugal_humberto_delgadoOptionsPromise
                  }
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.humberto_delgado_lisboa_cb}
                />
              )}
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="francisco_sa_carneiro_porto"
                Label={{ label: "Francisco Sá Carneiro (Porto)" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.francisco_sa_carneiro_porto}
              />
              {values.francisco_sa_carneiro_porto === "0" &&
                (values.francisco_sa_carneiro_porto_cb = null)}
              {values.francisco_sa_carneiro_porto === "1" && (
                <Field
                  name="francisco_sa_carneiro_porto_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={
                    aeroportos_de_portugal_francisco_sa_carneiroOptionsPromise
                  }
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.francisco_sa_carneiro_porto_cb}
                />
              )}
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="internacional_de_faro_algarve"
                Label={{ label: "Internacional de Faro (Algarve)" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.internacional_de_faro_algarve}
              />
              {values.internacional_de_faro_algarve === "0" &&
                (values.internacional_de_faro_algarve_cb = null)}
              {values.internacional_de_faro_algarve === "1" && (
                <Field
                  name="internacional_de_faro_algarve_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={
                    aeroportos_de_portugal_internacional_de_faroOptionsPromise
                  }
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.internacional_de_faro_algarve_cb}
                />
              )}
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="internacional_do_alentejo_beja"
                Label={{ label: "Internacional do Alentejo (Beja)" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.internacional_do_alentejo_beja}
              />
              {values.internacional_do_alentejo_beja === "0" &&
                (values.internacional_do_alentejo_beja_cb = null)}
              {values.internacional_do_alentejo_beja === "1" && (
                <Field
                  name="internacional_do_alentejo_beja_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={
                    aeroportos_de_portugal_internacional_do_alentejoOptionsPromise
                  }
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.internacional_do_alentejo_beja_cb}
                />
              )}
            </Grid>
          </Grid>
          <div className="servicesTitle" style={{ fontWeight: "bold" }}>
            Aceita
          </div>
          <Grid item md={12} className="checkboxAlign">
            <Grid item xs={3} className="comboCheck">
              <Field
                name="_65_anos"
                Label={{ label: "- 65 Anos" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values._65_anos}
              />
              {values._65_anos === "0" && (values._65_anos_cb = null)}
              {values._65_anos === "1" && (
                <Field
                  name="_65_anos_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={aceita_65_anosOptionsPromise}
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values._65_anos_cb}
                />
              )}
            </Grid>
            <Grid item xs={3} className="comboCheck">
              <Field
                name="estrangeiros"
                Label={{ label: "Estrangeiros" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.estrangeiros}
              />
              {values.estrangeiros === "0" && (values.estrangeiros_cb = null)}
              {values.estrangeiros === "1" && (
                <Field
                  name="estrangeiros_cb"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  optionsFetcher={aceita_estrangeirosOptionsPromise}
                  component={MaterialSelectFormik}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  value={"" + values.estrangeiros_cb}
                />
              )}
            </Grid>
            <Grid item xs={3}>
              <Field
                name="animais_de_estimacao"
                Label={{ label: "Animais de Estimação" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.animais_de_estimacao}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="estadias_temporarias"
                Label={{ label: "Estadias Temporárias" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.estadias_temporarias}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="deficiencia_motora"
                Label={{ label: "Deficiência Motora" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.deficiencia_motora}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="deficiencia_visual"
                Label={{ label: "Deficiência Visual" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.deficiencia_visual}
              />
            </Grid>
          </Grid>
          <div className="servicesTitle" style={{ fontWeight: "bold" }}>
            Interdito
          </div>
          <Grid item md={12} className="checkboxAlign">
            <Grid item xs={3}>
              <Field
                name="homens"
                Label={{ label: "Homens" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.homens}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="mulheres"
                Label={{ label: "Mulheres" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.mulheres}
              />
            </Grid>
          </Grid>
          <div className="servicesTitle" style={{ fontWeight: "bold" }}>
            Outras Valências
          </div>
          <Grid item md={12} className="checkboxAlign">
            <Grid item xs={3}>
              <Field
                name="centro_de_dia"
                Label={{ label: "Centro de Dia" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.centro_de_dia}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="apoio_no_domicilio"
                Label={{ label: "Apoio no Domicílio" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.apoio_no_domicilio}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                name="cuidados_continuados"
                Label={{ label: "Cuidados Continuados" }}
                component={CheckboxWithLabel}
                onChange={setFieldValue}
                value={"" + values.cuidados_continuados}
              />
            </Grid>
          </Grid>
          <br />
          <Button
            variant="contained"
            type="submit"
            size="small"
            style={{ marginTop: "20px" }}
          >
            Atualizar
          </Button>

          {isUpdating === true && (
            <div>
              <CircularProgress color="secondary" />
            </div>
          )}
        </form>
      );
    }}
  />
);
